module.exports = __webpack_public_path__ + "img/img04.6996bf2e.jpg";